import { render, staticRenderFns } from "./data-cell.vue?vue&type=template&id=613607d0&scoped=true&"
import script from "./data-cell.vue?vue&type=script&lang=js&"
export * from "./data-cell.vue?vue&type=script&lang=js&"
import style0 from "./data-cell.vue?vue&type=style&index=0&id=613607d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613607d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('613607d0')) {
      api.createRecord('613607d0', component.options)
    } else {
      api.reload('613607d0', component.options)
    }
    module.hot.accept("./data-cell.vue?vue&type=template&id=613607d0&scoped=true&", function () {
      api.rerender('613607d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bussiness/report-amount/components/data-cell.vue"
export default component.exports